// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"ec4a79c9","490":"cb14b299","609":"ad06dc6d","771":"210a5626","794":"5d78ebd8","797":"dcae6471","874":"43472943"}[chunkId] + ".chunk.js";
};